/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { ArrayExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IOrderLookupViewProps } from './dobbies-order-lookup';

/**
 * View component.
 * @param props - The view properties.
 * @returns - Returns JSX Element.
 */
export const OrderLookupViewComponent: React.FC<IOrderLookupViewProps> = props => {
    const {
        orderLookup,
        orderLookupContainer,
        orderLookupAdditionalFieldContainer,
        heading,
        paragraph,
        orderLookupForm,
        renderOrderLookupInputField,
        orderNumberInput,
        errorMessage,
        submitButton,
        additionalProperties,
        registeredUserMessage,
        fieldErrorMessage
    } = props;
    return (
        <Module {...orderLookup}>
            <Node {...orderLookupContainer}>
                {heading}
                {paragraph}
                <Node className={orderLookupForm?.className ?? ''}>
                    {orderNumberInput}
                    {renderOrderLookupInputField}
                    {ArrayExtensions.hasElements(additionalProperties) && (
                        <Node {...orderLookupAdditionalFieldContainer}>
                            {additionalProperties.map((item: JSX.Element) => (
                                <React.Fragment key=''>{item}</React.Fragment>
                            ))}
                        </Node>
                    )}
                    {fieldErrorMessage}
                    <Node {...submitButton} className={submitButton?.className ?? ''}>
                        {props.submitButtonLabelText}
                    </Node>
                    {errorMessage}
                </Node>
                {registeredUserMessage}
            </Node>
        </Module>
    );
};

export default OrderLookupViewComponent;
